import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * GET /v1/tenant/customers?tenantId=xxx
 * Fetch customers for a specific tenant
 */
export function fetchCustomersWithTenant(token: string, tenantId: number) {
  return axios.get(`${API_URL}/v1/tenant/customers?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * GET /v1/tenant/partners
 * Fetch partners
 */
export function fetchPartnersWithTenant(token: string) {
  return axios.get(`${API_URL}/v1/tenant/partners`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/**
 * GET /v1/suscription?tenantId=xxx
 * Fetch subscriptions for a specific tenant (same as HA clusters use)
 * Returns array of { id: number, purchaseOrden: string }
 */
export function fetchSubscriptionsForTenant(token: string, tenantId: number) {
  return axios.get(`${API_URL}/v1/suscription?tenantId=${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function getLicenseIdGlobal(
  subscription: string,
  id: number,
  tenant: number,
  token: string,

){
  return axios.get( `${API_URL}/v1/CTX-R/${subscription}/${id}?tenantId=${tenant}`,
  {
    headers:{Authorization:  `Bearer ${token}`} 
  }
)
}

export function getLicenseListGlobal(
    subscription: string,
    tenant: number,
    token: string,

){
  return axios.get( `${API_URL}/v1/CTX-R/${subscription}/list?tenantId=${tenant}`,
    {
      headers:{Authorization:  `Bearer ${token}`} 
    }
  )
}

export function getLicenseListByLicense(
  subscription: number | string,
  tenant: number,
  licenseId: number | string,
  token: string
) {
  return axios.get(
    `${API_URL}/v1/ctxr/${subscription}/listbylicence/${licenseId}?tenantId=${tenant}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}


export function updateLicense(
  licenseId:number,
  subscription: number,
  tenant: number,
  token: string,
  description: string
){
  return axios.put(
    `${API_URL}/v1/CTX-R/${subscription}/${licenseId}?tenantId=${tenant}` ,{description},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", 
      },
    }
  );
}

/**
 * What `POST /v1/CTX-R/add` answers. A missing field comes back as a 200 with
 * `error` ("startdate required"), not a 4xx, so only `subid` — the new
 * license's serial — says a license was created (CTX-1439).
 */
export interface CreateLicenseV1Response {
  subid?: string;
  error?: string;
}

/**
 * POST /v1/CTX-R/add
 * Creates a new license for v1 (Reflector v1.0)
 * @param token - Authentication token
 * @param payload - License payload (must include subscriptionId)
 * @param tenantId - Tenant ID
 */
export function createLicenseV1(
  token: string,
  payload: {
    tenantId: number;
    subscriptionId: string | number;
    description: string;
    type: string;
    startdate: string;
    enddate: string;
    total: string;
  },
  tenantId: number
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.post<CreateLicenseV1Response>(
    `${API_URL}/v1/CTX-R/add?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

/**
 * PUT /v1/CTX-R/-1/:licenseId
 * Updates an existing license for v1 (Reflector v1.0)
 * @param token - Authentication token
 * @param licenseId - License ID
 * @param payload - License payload (type, total, description, enddate, startdate)
 * @param tenantId - Tenant ID
 */
export function updateLicenseV1(
  token: string,
  licenseId: number,
  payload: {
    type: string;
    total: number;
    description: string;
    // Optional on purpose: the backend only rewrites a date it is sent, so an
    // edit leaves out the ones the user did not move (CTX-1438).
    enddate?: string;
    startdate?: string;
  },
  tenantId: number
) {
  const params = new URLSearchParams({
    tenantId: tenantId.toString()
  });
  return axios.put(
    `${API_URL}/v1/CTX-R/-1/${licenseId}?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}
